import { useDispatch } from 'react-redux';
import { chatErrorResetted } from '../../features/chat/chatSlice';
import { sendbird } from '../client/sendbird';

export const useSendbirdConnectionControls = () => {
    const dispatch = useDispatch();

    const disconnect = async (): Promise<void> => {
        console.log('Disconnection chat connection');
        await sendbird.disconnectWebSocket();
    };

    const reconnect = async (): Promise<void> => {
        console.log('Reconnection chat connection');
        sendbird.reconnect();
    };

    const resetChatErrors = () => {
        dispatch(chatErrorResetted());
    };

    return {
        disconnect,
        reconnect,
        resetChatErrors,
    };
};
